import { SerializedLegacyMessageFilter } from 'cio/types/conditions/legacy-filter';
import { NamedBitmapFilter, NotFilter } from 'cio/utils/filters';
import { MESSAGE_TYPE, TYPE_MAP } from 'cio/utils/named-bitmap-filters';
import { anyEmail } from 'cio/app-models/conditions/email';

export default function conditionToNamedBitmap(
  condition: SerializedLegacyMessageFilter,
): NamedBitmapFilter | NotFilter {
  let messageType = Object.entries<string>(TYPE_MAP).find(([key, _]) => key === condition.event.type);

  if (!messageType) {
    throw new Error('unknown message type');
  }

  let [, name] = messageType;

  if (condition.event.name !== anyEmail) {
    name = `${name}-${condition.event.name.replace('_*', '')}`;
  }

  let filter = {
    named_bitmap: {
      type: MESSAGE_TYPE,
      name: btoa(name), // the backend wants this base64 encoded
    },
  };

  if (condition.inverse) {
    return {
      not: filter,
    };
  }

  return filter;
}
